import {util} from '../../utils'

const actions = {
  biz: {
    demo: {
      queryData: ''
    },
    common: {
      queryEsData: ''
    },
    sys: {
      queryUserProps: '',
      queryEventMeta: '',
      queryEnvMeta: '',
      getCurrentUser: '',
      setCurrentApp: '',
      delEvent: '',
      editEvent: '',
      editEventProp: '',
      switchGroup: '',
      upsertGroup: '',
      delGroup: '',
      queryEventAttrs:''
    }
  },
  dataview: { // 实时概览
    getIgnoreConfig: '',
    getConfig: '',
    addConfig: '',
    delConfig: '',
    queryChartType: '',
    updateChartType: '',
    getGeo: ''
  },
  notice: {
    queryById: '',
    query: ''
  },
  userGroup: {
    query: ''
  },
  analysis: {
    queryData: '',
    appUpdateTime: ''
  },
  visualizer: {
    queryAndroidEvents: '',
    queryEvents: '',
    applyEvents: '',
    applyAllEvents: '',
    addEvent: '',
    removeEvents: '',
    checkEventName: '',
    delEvent: '',
    cancel: ''
  },
  userInfo: {
    getInfo: '',
    getSessions: '',
    getEventInfo: ''
  }
}

util.initializeConstants(actions, 'biz-action')
export default actions
